export const openRecordInNewTab = (path: string) => {
  window.open(path, '_blank', 'noopener,noreferrer');
};
